export default function registerToastStore() {
  let toastSequence = 0;
  const nextToastId = () => {
    toastSequence += 1;
    // Use a sequence + timestamp to avoid duplicate x-for keys.
    return `toast-${Date.now()}-${toastSequence}`;
  };

  window.Alpine.store('toastStore', {
    toasts: [], // Array to hold toast messages

    // Method to add a toast message
    addToast(message, type = 'success', duration = 10000) {
      const displayDelayMs = 500;
      const dismissAfterMs = Number.isFinite(duration) ? duration : 10000;

      setTimeout(() => {
        const toastId = nextToastId();
        if (!Array.isArray(this.toasts)) {
          this.toasts = [];
        }
        this.toasts.push({ id: toastId, message, type });

        // Automatically remove the toast after a specified duration.
        setTimeout(() => {
          this.removeToast(toastId);
        }, dismissAfterMs);
      }, displayDelayMs);
    },

    // Method to remove a toast message
    removeToast(toastId) {
      if (!Array.isArray(this.toasts)) {
        this.toasts = [];
        return;
      }
      this.toasts = this.toasts.filter(
        (toast) => toast && toast.id !== toastId,
      );
    },
  });
}
